import React from 'react';
import { ExceedConstrain } from '@moda/om';
import { TrunkshowListingPageFragment } from '../../generated/types';
import { TRUNKSHOW_SORT_OPTIONS } from '../../constants';
import { usePLPParams } from '../../hooks/usePLPParams';
import { StickUnderNav } from '../StickUnderNav';
import { ProductListingMobileFilter } from '../ProductListing/ProductListingMobile/ProductListingMobileFilter';
import { ProductListingMobileSort } from '../ProductListing/ProductListingMobile/ProductListingMobileSort';
import { createTrunkshowCategoryTree } from './createTrunkshowCategoryTree';

import './TrunkshowListingMobile.scss';

interface Props {
  queryResult: TrunkshowListingPageFragment;
  children?: React.ReactNode;
}

export const TrunkshowListingMobile: React.FC<Props> = ({ queryResult, children }) => {
  const { currentSort, changeSort } = usePLPParams(TRUNKSHOW_SORT_OPTIONS);

  return (
    <div className="TrunkshowListingMobile">
      <StickUnderNav className="TrunkshowListingMobile__actions-wrapper">
        <ExceedConstrain className="TrunkshowListingMobile__actions">
          <ProductListingMobileFilter
            queryResult={{
              categoryTree: createTrunkshowCategoryTree(queryResult),
              designers: queryResult.designers
            }}
            showPriceFilter={false}
          />
          <ProductListingMobileSort
            availableSorts={TRUNKSHOW_SORT_OPTIONS}
            currentSort={currentSort}
            onSortChanged={changeSort}
          />
        </ExceedConstrain>
      </StickUnderNav>
      {children}
    </div>
  );
};
